var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVscode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 128,
    height: 128,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M90.767 127.126a7.968 7.968 0 006.35-.244l26.353-12.681a8 8 0 004.53-7.209V21.009a8 8 0 00-4.53-7.21L97.117 1.12a7.97 7.97 0 00-9.093 1.548l-50.45 46.026L15.6 32.013a5.328 5.328 0 00-6.807.302l-7.048 6.411a5.335 5.335 0 00-.006 7.888L20.796 64 1.74 81.387a5.336 5.336 0 00.006 7.887l7.048 6.411a5.327 5.327 0 006.807.303l21.974-16.68 50.45 46.025a7.96 7.96 0 002.743 1.793zm5.252-92.183L57.74 64l38.28 29.058V34.943z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0065A9",
    d: "M123.471 13.82L97.097 1.12A7.973 7.973 0 0088 2.668L1.662 81.387a5.333 5.333 0 00.006 7.887l7.052 6.411a5.333 5.333 0 006.811.303l103.971-78.875c3.488-2.646 8.498-.158 8.498 4.22v-.306a8.001 8.001 0 00-4.529-7.208z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007ACC",
    d: "M123.471 114.181l-26.374 12.698A7.973 7.973 0 0188 125.333L1.662 46.613a5.333 5.333 0 01.006-7.887l7.052-6.411a5.333 5.333 0 016.811-.303l103.971 78.874c3.488 2.647 8.498.159 8.498-4.219v.306a8.001 8.001 0 01-4.529 7.208z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F9CF0",
    d: "M97.098 126.882A7.977 7.977 0 0188 125.333c2.952 2.952 8 .861 8-3.314V5.98c0-4.175-5.048-6.266-8-3.313a7.977 7.977 0 019.098-1.549L123.467 13.8A8 8 0 01128 21.01v85.982a8 8 0 01-4.533 7.21l-26.369 12.681z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "M90.69 127.126a7.968 7.968 0 006.349-.244l26.353-12.681a8 8 0 004.53-7.21V21.009a8 8 0 00-4.53-7.21L97.039 1.12a7.97 7.97 0 00-9.093 1.548l-50.45 46.026-21.974-16.68a5.328 5.328 0 00-6.807.302l-7.048 6.411a5.336 5.336 0 00-.006 7.888L20.718 64 1.662 81.386a5.335 5.335 0 00.006 7.888l7.048 6.411a5.328 5.328 0 006.807.303l21.975-16.681 50.45 46.026a7.959 7.959 0 002.742 1.793zm5.252-92.184L57.662 64l38.28 29.057V34.943z",
    clipRule: "evenodd",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 144.744,
    height: 113.408,
    x: -8.411,
    y: 22.594,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "overlay",
    result: "effect1_dropShadow_1_36"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_36",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 56.667,
    height: 144.007,
    x: 79.667,
    y: -8.004,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "overlay",
    result: "effect1_dropShadow_1_36"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_36",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 63.922,
    x2: 63.922,
    y1: 0.33,
    y2: 127.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.90d6a63bd8333ab484e87bffedff636b.svg";
export { ForwardRef as ReactComponent };